var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.5,
    fill: "white",
    stroke: "url(#paint0_linear_299_523)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7857 12.2143C21.5 11.9286 21.0714 11.9286 20.7857 12.2143L17 16L13.2143 12.2143C12.9286 11.9286 12.5 11.9286 12.2143 12.2143C11.9286 12.5 11.9286 12.9286 12.2143 13.2143L16 17L12.2143 20.7857C11.9286 21.0714 11.9286 21.5 12.2143 21.7857C12.3571 21.9286 12.5 22 12.7143 22C12.9286 22 13.0714 21.9286 13.2143 21.7857L17 18L20.7857 21.7857C20.9286 21.9286 21.1429 22 21.2857 22C21.4286 22 21.6429 21.9286 21.7857 21.7857C22.0714 21.5 22.0714 21.0714 21.7857 20.7857L18 17L21.7857 13.2143C22.0714 12.9286 22.0714 12.5 21.7857 12.2143Z",
    fill: "#22092C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_299_523",
    x1: 17,
    y1: 0,
    x2: 17,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480021,
    stopColor: "#E0D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515021,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.5c210f874174740dbb3ce0e11d8b0f3c.svg";
export { ForwardRef as ReactComponent };